import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import Section from '@/components/Section';
import AbilityCard from './components/AbilityCard';
import TechRow from './components/TechRow';
import { HERO, GENERATE, TECH } from './config';
import styles from './index.module.scss';

export default function Tutor() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image} alt={HERO.title} innerClassName={styles.heroInner}>
          <h1>{HERO.title}</h1>
          <p>{HERO.subtitle}</p>
        </PageHero>

        <Section title={GENERATE.title} subTitle={GENERATE.subTitle}>
          <div className={styles.generateLayout}>
            <div className={styles.smallCardRow}>
              {GENERATE.smallCards.map((card) => (
                <AbilityCard key={card.title} {...card} />
              ))}
            </div>
            <AbilityCard variant="wide" {...GENERATE.wideCard} />
          </div>
        </Section>

        <Section title={TECH.title} subTitle={TECH.subTitle}>
          <div className={styles.techLayout}>
            {TECH.rows.map((row) => (
              <TechRow key={row.title} {...row} />
            ))}
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
